import ActorVerbSubjectText from './ActorVerbSubjectText';

export default ActorVerbSubjectText;
